<script>
import { Bar } from "vue-chartjs";
export default {
	extends: Bar,
	props: {
		chartdata: {
			type: Object,
			default: null,
		},
		//  options: {
		//    type: Object,
		//    default: null
		//  }
	},
	data: () => ({
		options: {
			animation: {
				duration: 1000,
				easing: "linear",
			},
			maintainAspectRatio: false,
			responsive: true,
			scales: {
				yAxes: [{ ticks: { beginAtZero: true, stepSize: 5 } }],
            
			},
			legend: {
				display: true,
			},
			tooltips: {
				mode: "index",
			},
		},
	}),

	mounted() {
		this.renderChart(this.chartdata, this.options);
	},
};
</script>

<style>
</style>